<template>
  <loading v-if="!isInit"></loading>
  <div class="main-info" v-else>
    <div class="search">
      <h3>検索項目</h3>
      <div class="item-container">
        <div class="col-item shinsei-type">
          <b>申請種別</b>
          <select-box :options="ShinseiTypeOption" v-model="shinseiStore.item.shinseiType"
            :disabled="shinseiStore.item.searchStatus === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU" @update:modelValue="changeShinseiType"></select-box>
        </div>
        <div class="col-item shinsei-date">
          <b>取得年月</b>
          <month-picker v-model="shinseiStore.item.shinseiTargetMonth" :disabled="shinseiStore.item.searchStatus === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU"></month-picker>
        </div>
        <div class="col-item shinsei-date">
          <b>取得日</b>
          <date-picker v-model="shinseiStore.item.shinseiTargetDate" :disabled="shinseiStore.item.searchStatus === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU"></date-picker>
        </div>
      </div>

      <template
        v-if="authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOUNIN) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOZOKU) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_ALL)">
          <div class="item-container">
            <div class="col-item name">
              <b>氏名</b>
              <input-text type="text" v-model="shinseiStore.item.name" :disabled="shinseiStore.item.searchStatus === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU"></input-text>
            </div>
            <div class="col-item name">
              <b>社員番号</b>
              <input-text type="text" v-model="shinseiStore.item.staffCode" :disabled="shinseiStore.item.searchStatus === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU"></input-text>
            </div>
            <div class="col-item syuugyoubasyo" v-if="syuugyouBasyoOptions.length > 0">
              <b>就業場所</b>
              <select-box :options="syuugyouBasyoOptions" v-model="shinseiStore.item.syuugyouBasyoId" :hasBlank="true"></select-box>
            </div>
          </div>
      </template>

      <div class="item-container">
        <div class="col-item syounin-status">
          <b>承認種別</b>
          <input-radio :options="SyouninStatusOption" v-model="shinseiStore.item.shinseiStatus"
            :disabled="shinseiStore.item.searchStatus === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU || selectNoApprovalType"></input-radio>
        </div>
        <div class="col-item notice" v-if="selectNoApprovalType">
          <p class="color-red">※ 承認が不要な申請の場合この項目は選択できません。</p>
        </div>
      </div>
      <div class="item-container">
        <div class="col-item options">
          <b>表示</b>
          <template
            v-if="authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_ALL) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOUNIN) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOZOKU)">
            <input-radio @update:modelValue="changeListMode" :options="SearchStatusOption"
              v-model="shinseiStore.item.searchStatus"></input-radio>
          </template>
          <template v-else>
            <input-radio @update:modelValue="changeListMode" :options="SearchStatusOption.filter(v => { return v.hasOther })"
              v-model="shinseiStore.item.searchStatus"></input-radio>
          </template>
        </div>
      </div>
      <div class="btn-container">
        <button type="button" class="btn clear" @click="clear" :disabled="isSearching">クリア</button>
        <button type="button" class="btn primary" @click="search" :disabled="isSearching"><i class="fa-solid fa-magnifying-glass"></i>検索</button>
      </div>
    </div>
    <component :is="shinseiListComponentType" :isLoading="isSearching" :isError="isError" :isInit="isInit"
      :dataList="shinseiList" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, Ref } from "vue";
import { useShinseiList } from "@/composable/shinsei/list/list";
import { useForm } from "@/composable/form/form";
import { RouterConst } from '@/const/Router';
import { useShinseiStore } from '@/store/shinsei';
import { useRouter } from "vue-router";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";
import List from "@/components/shinsei/list/parts/List.vue";
import ZangyouList from "@/components/shinsei/list/parts/ZangyouList.vue";
import OptionConst from "@/const/Option";
import ShinseiOptionConst from "@/const/Shinsei/Option";

export default defineComponent({
  setup() {
    // 初期化
    const authStore = useAuthStore()
    const { getShinseiList, isError, shinseiList, shinseiListComponentType } = useShinseiList();
    const shinseiStore = useShinseiStore();
    // const { getAllSyuugyouBasyoOptions, syuugyouBasyoOptions } = useSyuugyouBasyoInit();
    const syuugyouBasyo = useSyuugyouBasyoInit()
    const isInit = ref(false);
    const isSearching = ref(false);
    const router = useRouter();
    const canSyuugyouBasyo: Ref<Boolean> = ref(false);
    const selectNoApprovalType = ref(false);

    // 就業場所選択の権限を持つかチェック
    const checkCanSelectSyuugyouBasyo = async () => {
      canSyuugyouBasyo.value = authStore.hasPermission(PermissionConst.SYUUGYOU_BASYO_GET_ALL)
    }

    // 検索ボタンクリック
    const search = async () => {
      isSearching.value = true;
      await shinseiStore.setItem(shinseiStore.item);
      await getShinseiList(shinseiStore.item);
      isSearching.value = false;
    };

    // クリアボタンクリック
    const clear = async () => {
      selectNoApprovalType.value = false
      await shinseiStore.clear()
    }

    // 初期取得
    onMounted(async () => {
      isInit.value = false;
      // 社員情報一覧取得
      await getShinseiList(shinseiStore.item);
      // 就業場所取得
      await checkCanSelectSyuugyouBasyo()
      if (canSyuugyouBasyo.value) {
        syuugyouBasyo.getAllSyuugyouBasyoOptions()
      }
      isInit.value = true;
    });

    const changeListMode = (mode: number) => {
      // console.log("changeListMode", mode)
      if (mode === ShinseiOptionConst.SEARCH_STATUS.ZANGYOU) {
        shinseiStore.item.shinseiType = OptionConst.SHINSEI_CODE.JIKANGAI
        shinseiStore.item.shinseiStatus = null
      }
    }
    // エラー取得
    const { getError } = useForm();

    const changeShinseiType = (mode: number) => {
      switch (mode) {
        case OptionConst.SHINSEI_CODE_NO_APPROVAL.HAYABAN_OSOBAN:
        case OptionConst.SHINSEI_CODE_NO_APPROVAL.KOUKYUU:
          selectNoApprovalType.value = true
          shinseiStore.item.shinseiStatus = null
          break;
        default:
          selectNoApprovalType.value = false
          break;
      }

    }

    return {
      getError,
      search,
      clear,
      shinseiList,
      shinseiListComponentType,
      isError,
      isInit,
      isSearching,
      "ShinseiTypeOption": OptionConst.SHINSEI_OPTION_WITH_NO_APPROVAL,
      "SyouninStatusOption": OptionConst.SHINSEI_SYOUNIN_STATUS_OPTION,
      "SearchStatusOption": ShinseiOptionConst.SEARCH_STATUS_OPTION,
      RouterConst,
      'syuugyouBasyoOptions': syuugyouBasyo.syuugyouBasyoOptions,
      router,
      authStore,
      PermissionConst,
      ShinseiOptionConst,
      changeListMode,
      shinseiStore,
      changeShinseiType,
      selectNoApprovalType
    };
  },
  components: {
    list: List,
    zangyouList: ZangyouList,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-list.scss';
</style>
